import {InfoCircleOutlined} from '@ant-design/icons'
import {Form, Input, Select} from 'antd'
import React from 'react'
import {useIntl} from 'react-intl'
import {DatabasePlantRecordField} from '../../../entities/plant'
import {RangeField} from './RangeField'
import './rangeField.less'

export function renderFieldGroup(
  group: [key: string, field: DatabasePlantRecordField][],
  preventFormCloseDueToModification: () => void
) {
  const intl = useIntl()

  return group.map(([key, field], index) => {
    let element: React.ReactNode = null
    if (field.type === 'range-start') {
      const fieldTo = group.find((f) => f[1].type === 'range-end' && f[1].rangeId === field.rangeId)
      return (
        <RangeField
          key={key}
          fieldName={field.rangeId}
          fieldKeyFrom={key}
          filedFrom={field}
          fieldKeyTo={fieldTo[0]}
          fieldTo={fieldTo[1]}
        />
      )
    } else if (field.type === 'text') {
      element = <Input.TextArea key={index} autoSize />
    } else if (field.type === 'enum-dropdown') {
      element = (
        <Select
          key={index}
          allowClear
          onChange={preventFormCloseDueToModification}
          options={field.options.map((option) => ({
            value: option,
            label: field.monthsOptions
              ? intl.formatMessage({id: option})
              : intl.formatMessage({id: `${field.translationId}-${option}`}),
          }))}
          mode={field.multiple === true ? 'multiple' : undefined}
        ></Select>
      )
    }
    if (!element) {
      return null
    }

    return (
      <Form.Item
        key={key}
        name={key}
        label={intl.formatMessage({id: field.translationId})}
        tooltip={
          field.tooltip
            ? {
                title: intl.formatMessage({id: `${field.translationId}-tooltip`}),
                icon: <InfoCircleOutlined />,
              }
            : null
        }
      >
        {element}
      </Form.Item>
    )
  })
}
